import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { getHangerState, getSettingsState } from '../../../../../store/selectors'

import {
  HANGER_TYPE,
  SKEW_DEGREES_MARKS,
  SLOPE_DEGREES_MARKS,
} from '../../../../../common/constants'

import { FormGroup, FormLabel, RangeSlider } from '../../../../../../../components'

const AngleOptions = ({ errors, hangerType, onChange, onValidateField }) => {
  const { skewAngle, slopeAngle } = useSelector(getHangerState)
  const { connectionType } = useSelector(getSettingsState)

  const handleChangeSkew = (e) => {
    onValidateField(e)
    onChange({
      [e.target.name]: e.target.value,
    })
  }

  const handleChangeSlope = (e) => {
    onValidateField(e)
    onChange({
      [e.target.name]: e.target.value,
    })
  }

  return (
    <div className="grid grid__auto--400 grid--gap-1-2">
      <FormGroup
        className="skewDegrees"
        warning={hangerType === HANGER_TYPE.CONCEALED && parseFloat(skewAngle) !== 0}
      >
        <FormLabel
          htmlFor="hanger.skewAngle"
          warning={hangerType === HANGER_TYPE.CONCEALED && parseFloat(skewAngle) !== 0}
        >
          Skew (Degrees)
        </FormLabel>
        <RangeSlider
          name="hanger.skewAngle"
          value={skewAngle}
          onChange={handleChangeSkew}
          min={-85}
          max={85}
          addonBefore="Left"
          addonAfter="Right"
          marks={SKEW_DEGREES_MARKS}
          error={errors['hanger.skewAngle']}
          data-ga4={`${connectionType}_angle_skewValue:${skewAngle}`}
          data-testid="hanger.skewAngle"
        />
      </FormGroup>

      <FormGroup
        className="slopeDegrees"
        warning={hangerType === HANGER_TYPE.CONCEALED && parseFloat(slopeAngle) !== 0}
      >
        <FormLabel
          htmlFor="hanger.slopeAngle"
          warning={hangerType === HANGER_TYPE.CONCEALED && parseFloat(slopeAngle) !== 0}
        >
          Slope (Degrees)
        </FormLabel>
        <RangeSlider
          name="hanger.slopeAngle"
          value={slopeAngle}
          onChange={handleChangeSlope}
          min={-49}
          max={49}
          addonBefore="Up"
          addonAfter="Down"
          marks={SLOPE_DEGREES_MARKS}
          error={errors['hanger.slopeAngle']}
          data-ga4={`${connectionType}_angle_slopeValue:${slopeAngle}`}
          data-testid="hanger.slopeAngle"
        />
      </FormGroup>
    </div>
  )
}

AngleOptions.propTypes = {
  hangerType: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onValidateField: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

export default memo(AngleOptions)
